<template>
  <component
    :is="reviewsUrl ? 'a' : 'div'"
    :href="reviewsUrl || undefined"
    :target="reviewsUrl ? '_blank' : undefined"
    :rel="reviewsUrl ? 'noopener' : undefined"
    class="trustpilot-badge"
  >
    <div class="trustpilot-badge__label">{{ excellentLabel }}</div>
    <trustpilot-stars :count="starsCount" :size="22" />
    <div
      v-if="ratingText"
      class="trustpilot-badge__rating-line"
      v-html="ratingText"
    />
    <div class="trustpilot-badge__wordmark">
      <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          d="M12 2l2.94 6.94L22 9.6l-5.5 4.78L18.1 22 12 18.27 5.9 22l1.6-7.62L2 9.6l7.06-.66L12 2z"
          fill="#00b67a"
        />
      </svg>
      <span>Trustpilot</span>
    </div>
  </component>
</template>

<script>
import { sprintf } from 'sprintf-js';
import { getStarLabel } from '../misc/helpers';
import TrustpilotStars from './TrustpilotStars.vue';

export default {
  name: 'TrustpilotBadge',

  components: {
    TrustpilotStars,
  },

  props: {
    averageRating: {
      type: String,
      default: null,
    },
    numberOfRatings: {
      type: String,
      default: null,
    },
    reviewsUrl: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      texts: window.theme_vars.trustpilot,
    };
  },

  computed: {
    numericAverage() {
      const value = Number.parseFloat(this.averageRating);
      return Number.isFinite(value) ? value : 5;
    },

    starsCount() {
      return Math.round(this.numericAverage);
    },

    excellentLabel() {
      return getStarLabel(this.numericAverage);
    },

    safeAverageRating() {
      const value = Number.parseFloat(this.averageRating);
      return Number.isFinite(value) ? value.toFixed(1) : '';
    },

    safeNumberOfRatings() {
      const value = Number.parseInt(
        String(this.numberOfRatings ?? '').replace(/[^\d]/g, ''),
        10,
      );
      return Number.isFinite(value) ? String(value) : '';
    },

    ratingText() {
      if (!this.safeAverageRating || !this.safeNumberOfRatings || !this.texts.ratingText) {
        return '';
      }
      return sprintf(
        this.texts.ratingText,
        this.safeAverageRating,
        this.safeNumberOfRatings,
      );
    },
  },
};
</script>
